import * as tslib_1 from "tslib";
import { EvalStack } from './eval-stack';
import { Item } from './item';
import { Value } from './value';
import { DynamicValue } from './dynamic-value';
import { Murmur3 } from './murmur3';
var Expr = (function (_super) {
    tslib_1.__extends(Expr, _super);
    function Expr() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Expr.prototype.compare = function (that) {
        if (that instanceof Expr) {
            return 0;
        }
        else if (that === Value.Extant || that === Value.Absent) {
            return -1;
        }
        else {
            return 1;
        }
    };
    Expr.prototype.toString = function () {
        return this.toRecon();
    };
    return Expr;
}(DynamicValue));
export { Expr };
Item.Expr = Expr;
var InfixExpr = (function (_super) {
    tslib_1.__extends(InfixExpr, _super);
    function InfixExpr(lhs, rhs) {
        var _this = _super.call(this) || this;
        _this.lhs = lhs.commit();
        _this.rhs = rhs.commit();
        return _this;
    }
    InfixExpr.prototype.writeRecon = function (output) {
        if (this.lhs.precedence < this.precedence) {
            output.push(40);
            this.lhs.writeRecon(output);
            output.push(41);
        }
        else {
            this.lhs.writeRecon(output);
        }
        output.push(32);
        Item.Text.writeIdent(this.operator, output);
        output.push(32);
        if (this.rhs.precedence < this.precedence) {
            output.push(40);
            this.rhs.writeRecon(output);
            output.push(41);
        }
        else {
            this.rhs.writeRecon(output);
        }
    };
    return InfixExpr;
}(Expr));
export { InfixExpr };
var PrefixExpr = (function (_super) {
    tslib_1.__extends(PrefixExpr, _super);
    function PrefixExpr(rhs) {
        var _this = _super.call(this) || this;
        _this.rhs = rhs.commit();
        return _this;
    }
    PrefixExpr.prototype.writeRecon = function (output) {
        Item.Text.writeIdent(this.operator, output);
        if (this.rhs.precedence < this.precedence) {
            output.push(40);
            this.rhs.writeRecon(output);
            output.push(41);
        }
        else {
            this.rhs.writeRecon(output);
        }
    };
    return PrefixExpr;
}(Expr));
export { PrefixExpr };
var CondExpr = (function (_super) {
    tslib_1.__extends(CondExpr, _super);
    function CondExpr(predExpr, thenExpr, elseExpr) {
        var _this = _super.call(this) || this;
        _this.predExpr = predExpr.commit();
        _this.thenExpr = thenExpr.commit();
        _this.elseExpr = elseExpr.commit();
        return _this;
    }
    Object.defineProperty(CondExpr.prototype, "precedence", {
        get: function () {
            return 1;
        },
        enumerable: true,
        configurable: true
    });
    CondExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var predValue = this.predExpr.evaluate(stack);
        if (predValue.isDefined()) {
            var thenValue = this.thenExpr.evaluate(stack);
            return thenValue;
        }
        else {
            var elseValue = this.elseExpr.evaluate(stack);
            return elseValue;
        }
    };
    CondExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var predExpr = this.predExpr.substitute(stack).toValue();
        var thenExpr = this.thenExpr.substitute(stack).toValue();
        var elseExpr = this.elseExpr.substitute(stack).toValue();
        return new CondExpr(predExpr, thenExpr, elseExpr);
    };
    CondExpr.prototype.writeRecon = function (output) {
        if (this.predExpr instanceof CondExpr) {
            output.push(40);
            this.predExpr.writeRecon(output);
            output.push(41);
        }
        else {
            this.predExpr.writeRecon(output);
        }
        output.push(32);
        output.push(63);
        output.push(32);
        this.thenExpr.writeRecon(output);
        output.push(32);
        output.push(58);
        output.push(32);
        this.elseExpr.writeRecon(output);
    };
    CondExpr.prototype.clone = function () {
        return new CondExpr(this.predExpr.clone(), this.thenExpr.clone(), this.elseExpr.clone());
    };
    CondExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof CondExpr) {
            return this.predExpr.equals(that.predExpr) && this.thenExpr.equals(that.thenExpr)
                && this.elseExpr.equals(that.elseExpr);
        }
        return false;
    };
    CondExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(Murmur3.mix(0xA01D34F1, this.predExpr.hashCode()), this.thenExpr.hashCode()), this.elseExpr.hashCode()));
    };
    return CondExpr;
}(Expr));
export { CondExpr };
Item.CondExpr = CondExpr;
var LorExpr = (function (_super) {
    tslib_1.__extends(LorExpr, _super);
    function LorExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(LorExpr.prototype, "operator", {
        get: function () {
            return '||';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LorExpr.prototype, "precedence", {
        get: function () {
            return 2;
        },
        enumerable: true,
        configurable: true
    });
    LorExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        if (lvalue.isDefined()) {
            return lvalue;
        }
        else {
            var rvalue = this.rhs.evaluate(stack);
            return rvalue;
        }
    };
    LorExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.or(rvalue);
    };
    LorExpr.prototype.clone = function () {
        return new LorExpr(this.lhs.clone(), this.rhs.clone());
    };
    LorExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof LorExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    LorExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0xA425A728, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return LorExpr;
}(InfixExpr));
export { LorExpr };
Item.LorExpr = LorExpr;
var LandExpr = (function (_super) {
    tslib_1.__extends(LandExpr, _super);
    function LandExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(LandExpr.prototype, "operator", {
        get: function () {
            return '&&';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandExpr.prototype, "precedence", {
        get: function () {
            return 3;
        },
        enumerable: true,
        configurable: true
    });
    LandExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        if (lvalue.isDefined()) {
            var rvalue = this.rhs.evaluate(stack);
            return rvalue;
        }
        else {
            return lvalue;
        }
    };
    LandExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.and(rvalue);
    };
    LandExpr.prototype.clone = function () {
        return new LandExpr(this.lhs.clone(), this.rhs.clone());
    };
    LandExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof LandExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    LandExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0xB4CCC7B9, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return LandExpr;
}(InfixExpr));
export { LandExpr };
Item.LandExpr = LandExpr;
var BorExpr = (function (_super) {
    tslib_1.__extends(BorExpr, _super);
    function BorExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(BorExpr.prototype, "operator", {
        get: function () {
            return '|';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BorExpr.prototype, "precedence", {
        get: function () {
            return 4;
        },
        enumerable: true,
        configurable: true
    });
    BorExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.bor(rvalue);
    };
    BorExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.bor(rvalue);
    };
    BorExpr.prototype.clone = function () {
        return new BorExpr(this.lhs.clone(), this.rhs.clone());
    };
    BorExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof BorExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    BorExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0xAFE940A7, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return BorExpr;
}(InfixExpr));
export { BorExpr };
Item.BorExpr = BorExpr;
var BxorExpr = (function (_super) {
    tslib_1.__extends(BxorExpr, _super);
    function BxorExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(BxorExpr.prototype, "operator", {
        get: function () {
            return '^';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BxorExpr.prototype, "precedence", {
        get: function () {
            return 5;
        },
        enumerable: true,
        configurable: true
    });
    BxorExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.bxor(rvalue);
    };
    BxorExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.bxor(rvalue);
    };
    BxorExpr.prototype.clone = function () {
        return new BxorExpr(this.lhs.clone(), this.rhs.clone());
    };
    BxorExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof BxorExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    BxorExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x9680D943, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return BxorExpr;
}(InfixExpr));
export { BxorExpr };
Item.BxorExpr = BxorExpr;
var BandExpr = (function (_super) {
    tslib_1.__extends(BandExpr, _super);
    function BandExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(BandExpr.prototype, "operator", {
        get: function () {
            return '&';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BandExpr.prototype, "precedence", {
        get: function () {
            return 6;
        },
        enumerable: true,
        configurable: true
    });
    BandExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.band(rvalue);
    };
    BandExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.band(rvalue);
    };
    BandExpr.prototype.clone = function () {
        return new BandExpr(this.lhs.clone(), this.rhs.clone());
    };
    BandExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof BandExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    BandExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x6849F7D0, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return BandExpr;
}(InfixExpr));
export { BandExpr };
Item.BandExpr = BandExpr;
var LtExpr = (function (_super) {
    tslib_1.__extends(LtExpr, _super);
    function LtExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(LtExpr.prototype, "operator", {
        get: function () {
            return '<';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LtExpr.prototype, "precedence", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    LtExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.lt(rvalue);
    };
    LtExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.lt(rvalue);
    };
    LtExpr.prototype.clone = function () {
        return new LtExpr(this.lhs.clone(), this.rhs.clone());
    };
    LtExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof LtExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    LtExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x39A4927F, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return LtExpr;
}(InfixExpr));
export { LtExpr };
Item.LtExpr = LtExpr;
var LeExpr = (function (_super) {
    tslib_1.__extends(LeExpr, _super);
    function LeExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(LeExpr.prototype, "operator", {
        get: function () {
            return '<=';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeExpr.prototype, "precedence", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    LeExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.le(rvalue);
    };
    LeExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.le(rvalue);
    };
    LeExpr.prototype.clone = function () {
        return new LeExpr(this.lhs.clone(), this.rhs.clone());
    };
    LeExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof LeExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    LeExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x62DD658C, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return LeExpr;
}(InfixExpr));
export { LeExpr };
Item.LeExpr = LeExpr;
var EqExpr = (function (_super) {
    tslib_1.__extends(EqExpr, _super);
    function EqExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(EqExpr.prototype, "operator", {
        get: function () {
            return '==';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EqExpr.prototype, "precedence", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    EqExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.eq(rvalue);
    };
    EqExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.eq(rvalue);
    };
    EqExpr.prototype.clone = function () {
        return new EqExpr(this.lhs.clone(), this.rhs.clone());
    };
    EqExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof EqExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    EqExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x09007838, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return EqExpr;
}(InfixExpr));
export { EqExpr };
Item.EqExpr = EqExpr;
var NeExpr = (function (_super) {
    tslib_1.__extends(NeExpr, _super);
    function NeExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(NeExpr.prototype, "operator", {
        get: function () {
            return '!=';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NeExpr.prototype, "precedence", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    NeExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.ne(rvalue);
    };
    NeExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.ne(rvalue);
    };
    NeExpr.prototype.clone = function () {
        return new NeExpr(this.lhs.clone(), this.rhs.clone());
    };
    NeExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof NeExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    NeExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0xCAB339BA, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return NeExpr;
}(InfixExpr));
export { NeExpr };
Item.NeExpr = NeExpr;
var GeExpr = (function (_super) {
    tslib_1.__extends(GeExpr, _super);
    function GeExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(GeExpr.prototype, "operator", {
        get: function () {
            return '>=';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeExpr.prototype, "precedence", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    GeExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.ge(rvalue);
    };
    GeExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.ge(rvalue);
    };
    GeExpr.prototype.clone = function () {
        return new GeExpr(this.lhs.clone(), this.rhs.clone());
    };
    GeExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof GeExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    GeExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x2100DA05, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return GeExpr;
}(InfixExpr));
export { GeExpr };
Item.GeExpr = GeExpr;
var GtExpr = (function (_super) {
    tslib_1.__extends(GtExpr, _super);
    function GtExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(GtExpr.prototype, "operator", {
        get: function () {
            return '>';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GtExpr.prototype, "precedence", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    GtExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.gt(rvalue);
    };
    GtExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.gt(rvalue);
    };
    GtExpr.prototype.clone = function () {
        return new GtExpr(this.lhs.clone(), this.rhs.clone());
    };
    GtExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof GtExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    GtExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x8E6240B5, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return GtExpr;
}(InfixExpr));
export { GtExpr };
Item.GtExpr = GtExpr;
var AddExpr = (function (_super) {
    tslib_1.__extends(AddExpr, _super);
    function AddExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(AddExpr.prototype, "operator", {
        get: function () {
            return '+';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddExpr.prototype, "precedence", {
        get: function () {
            return 7;
        },
        enumerable: true,
        configurable: true
    });
    AddExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.plus(rvalue);
    };
    AddExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.plus(rvalue);
    };
    AddExpr.prototype.clone = function () {
        return new AddExpr(this.lhs.clone(), this.rhs.clone());
    };
    AddExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof AddExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    AddExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0xBB5AB088, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return AddExpr;
}(InfixExpr));
export { AddExpr };
Item.AddExpr = AddExpr;
var SubExpr = (function (_super) {
    tslib_1.__extends(SubExpr, _super);
    function SubExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(SubExpr.prototype, "operator", {
        get: function () {
            return '-';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubExpr.prototype, "precedence", {
        get: function () {
            return 7;
        },
        enumerable: true,
        configurable: true
    });
    SubExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.minus(rvalue);
    };
    SubExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.minus(rvalue);
    };
    SubExpr.prototype.clone = function () {
        return new SubExpr(this.lhs.clone(), this.rhs.clone());
    };
    SubExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof SubExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    SubExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x775F2746, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return SubExpr;
}(InfixExpr));
export { SubExpr };
Item.SubExpr = SubExpr;
var MulExpr = (function (_super) {
    tslib_1.__extends(MulExpr, _super);
    function MulExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(MulExpr.prototype, "operator", {
        get: function () {
            return '*';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MulExpr.prototype, "precedence", {
        get: function () {
            return 8;
        },
        enumerable: true,
        configurable: true
    });
    MulExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.times(rvalue);
    };
    MulExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.times(rvalue);
    };
    MulExpr.prototype.clone = function () {
        return new MulExpr(this.lhs.clone(), this.rhs.clone());
    };
    MulExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof MulExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    MulExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0xD19ED189, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return MulExpr;
}(InfixExpr));
export { MulExpr };
Item.MulExpr = MulExpr;
var DivExpr = (function (_super) {
    tslib_1.__extends(DivExpr, _super);
    function DivExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(DivExpr.prototype, "operator", {
        get: function () {
            return '/';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DivExpr.prototype, "precedence", {
        get: function () {
            return 8;
        },
        enumerable: true,
        configurable: true
    });
    DivExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.divide(rvalue);
    };
    DivExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.divide(rvalue);
    };
    DivExpr.prototype.clone = function () {
        return new DivExpr(this.lhs.clone(), this.rhs.clone());
    };
    DivExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof DivExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    DivExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x2318A446, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return DivExpr;
}(InfixExpr));
export { DivExpr };
Item.DivExpr = DivExpr;
var ModExpr = (function (_super) {
    tslib_1.__extends(ModExpr, _super);
    function ModExpr(lhs, rhs) {
        return _super.call(this, lhs, rhs) || this;
    }
    Object.defineProperty(ModExpr.prototype, "operator", {
        get: function () {
            return '%';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModExpr.prototype, "precedence", {
        get: function () {
            return 8;
        },
        enumerable: true,
        configurable: true
    });
    ModExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.evaluate(stack);
        var rvalue = this.rhs.evaluate(stack);
        return lvalue.modulo(rvalue);
    };
    ModExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var lvalue = this.lhs.substitute(stack);
        var rvalue = this.rhs.substitute(stack);
        return lvalue.modulo(rvalue);
    };
    ModExpr.prototype.clone = function () {
        return new ModExpr(this.lhs.clone(), this.rhs.clone());
    };
    ModExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof ModExpr) {
            return this.lhs.equals(that.lhs) && this.rhs.equals(that.rhs);
        }
        return false;
    };
    ModExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0x73A0433A, this.lhs.hashCode()), this.rhs.hashCode()));
    };
    return ModExpr;
}(InfixExpr));
export { ModExpr };
Item.ModExpr = ModExpr;
var LnotExpr = (function (_super) {
    tslib_1.__extends(LnotExpr, _super);
    function LnotExpr(rhs) {
        return _super.call(this, rhs) || this;
    }
    Object.defineProperty(LnotExpr.prototype, "operator", {
        get: function () {
            return '!';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LnotExpr.prototype, "precedence", {
        get: function () {
            return 9;
        },
        enumerable: true,
        configurable: true
    });
    LnotExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var rvalue = this.rhs.evaluate(stack);
        return rvalue.not();
    };
    LnotExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var rvalue = this.rhs.substitute(stack);
        return rvalue.not();
    };
    LnotExpr.prototype.clone = function () {
        return new LnotExpr(this.rhs.clone());
    };
    LnotExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof LnotExpr) {
            return this.rhs.equals(that.rhs);
        }
        return false;
    };
    LnotExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(0x5E85FAB0, this.rhs.hashCode()));
    };
    return LnotExpr;
}(PrefixExpr));
export { LnotExpr };
Item.LnotExpr = LnotExpr;
var BnotExpr = (function (_super) {
    tslib_1.__extends(BnotExpr, _super);
    function BnotExpr(rhs) {
        return _super.call(this, rhs) || this;
    }
    Object.defineProperty(BnotExpr.prototype, "operator", {
        get: function () {
            return '~';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BnotExpr.prototype, "precedence", {
        get: function () {
            return 9;
        },
        enumerable: true,
        configurable: true
    });
    BnotExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var rvalue = this.rhs.evaluate(stack);
        return rvalue.bnot();
    };
    BnotExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var rvalue = this.rhs.substitute(stack);
        return rvalue.bnot();
    };
    BnotExpr.prototype.clone = function () {
        return new BnotExpr(this.rhs.clone());
    };
    BnotExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof BnotExpr) {
            return this.rhs.equals(that.rhs);
        }
        return false;
    };
    BnotExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(0x25F0BBE8, this.rhs.hashCode()));
    };
    return BnotExpr;
}(PrefixExpr));
export { BnotExpr };
Item.BnotExpr = BnotExpr;
var NegExpr = (function (_super) {
    tslib_1.__extends(NegExpr, _super);
    function NegExpr(rhs) {
        return _super.call(this, rhs) || this;
    }
    Object.defineProperty(NegExpr.prototype, "operator", {
        get: function () {
            return '-';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NegExpr.prototype, "precedence", {
        get: function () {
            return 9;
        },
        enumerable: true,
        configurable: true
    });
    NegExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var rvalue = this.rhs.evaluate(stack);
        return rvalue.neg();
    };
    NegExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var rvalue = this.rhs.substitute(stack);
        return rvalue.neg();
    };
    NegExpr.prototype.clone = function () {
        return new NegExpr(this.rhs.clone());
    };
    NegExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof NegExpr) {
            return this.rhs.equals(that.rhs);
        }
        return false;
    };
    NegExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(0x2052334D, this.rhs.hashCode()));
    };
    return NegExpr;
}(PrefixExpr));
export { NegExpr };
Item.NegExpr = NegExpr;
var PosExpr = (function (_super) {
    tslib_1.__extends(PosExpr, _super);
    function PosExpr(rhs) {
        return _super.call(this, rhs) || this;
    }
    Object.defineProperty(PosExpr.prototype, "operator", {
        get: function () {
            return '+';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PosExpr.prototype, "precedence", {
        get: function () {
            return 9;
        },
        enumerable: true,
        configurable: true
    });
    PosExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var rvalue = this.rhs.evaluate(stack);
        return rvalue.pos();
    };
    PosExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var rvalue = this.rhs.substitute(stack);
        return rvalue.pos();
    };
    PosExpr.prototype.clone = function () {
        return new PosExpr(this.rhs.clone());
    };
    PosExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof PosExpr) {
            return this.rhs.equals(that.rhs);
        }
        return false;
    };
    PosExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(0xC4C02A1E, this.rhs.hashCode()));
    };
    return PosExpr;
}(PrefixExpr));
export { PosExpr };
Item.PosExpr = PosExpr;
var InvokeExpr = (function (_super) {
    tslib_1.__extends(InvokeExpr, _super);
    function InvokeExpr(func, args) {
        var _this = _super.call(this) || this;
        _this.func = func;
        _this.args = args.commit();
        return _this;
    }
    Object.defineProperty(InvokeExpr.prototype, "precedence", {
        get: function () {
            return 10;
        },
        enumerable: true,
        configurable: true
    });
    InvokeExpr.prototype.evaluate = function (stack) {
        stack = EvalStack.fromAny(stack);
        var func = this.func.evaluate(stack);
        if (func instanceof Item.Func) {
            return func.invoke(this.args, stack, this);
        }
        return Value.Absent;
    };
    InvokeExpr.prototype.substitute = function (stack) {
        stack = EvalStack.fromAny(stack);
        var func = this.func.evaluate(stack);
        if (func instanceof Item.Func) {
            var result = func.partialInvoke(this.args, stack, this);
            if (result) {
                return result;
            }
        }
        var args = this.args.substitute(stack).toValue();
        return new InvokeExpr(this.func, args);
    };
    InvokeExpr.prototype.writeRecon = function (output) {
        this.func.writeRecon(output);
        output.push(40);
        this.args.writeReconBlock(output);
        output.push(41);
    };
    InvokeExpr.prototype.clone = function () {
        return new InvokeExpr(this.func.clone(), this.args.clone());
    };
    InvokeExpr.prototype.equals = function (that) {
        if (this === that) {
            return true;
        }
        else if (that instanceof InvokeExpr) {
            return this.func.equals(that.func) && this.args.equals(that.args);
        }
        return false;
    };
    InvokeExpr.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(Murmur3.mix(0xA214818C, this.func.hashCode()), this.args.hashCode()));
    };
    return InvokeExpr;
}(Expr));
export { InvokeExpr };
Item.InvokeExpr = InvokeExpr;
//# sourceMappingURL=data:application/json;base64,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